module.exports = __webpack_public_path__ + "img/AV_004_inicio_portal_clientes_sinletra.8477b950.jpg";